import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { User } from '~/composables/useAuth'

export const useAuthStore = defineStore('auth', () => {
  // State - all as refs for reactivity
  const user = ref<User | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)
  const status = ref<'loading' | 'authenticated' | 'unauthenticated'>('loading')
  const unauthenticatedReason = ref<string | null>(null)
  const siteActiveIdDebug = ref<string | null>(null)
  const sessionTimeoutHandled = ref(false)
  
  // Actions
  const setUser = (newUser: User | null) => {
    user.value = newUser
    updateStatus()
  }
  
  const setLoading = (isLoading: boolean) => {
    loading.value = isLoading
    updateStatus()
  }
  
  const setError = (errorMessage: string | null) => {
    error.value = errorMessage
  }
  
  const updateStatus = () => {
    if (loading.value) {
      status.value = 'loading'
      unauthenticatedReason.value = null
    } else if (user.value) {
      status.value = 'authenticated'
      unauthenticatedReason.value = null
    } else {
      status.value = 'unauthenticated'
    }
  }
  
  const reset = () => {
    user.value = null
    loading.value = false
    error.value = null
    status.value = 'unauthenticated'
    unauthenticatedReason.value = null
    siteActiveIdDebug.value = null
    sessionTimeoutHandled.value = false
  }
  
  return {
    // State - expose refs directly
    user,
    loading,
    error,
    status,
    unauthenticatedReason,
    siteActiveIdDebug,
    sessionTimeoutHandled,
    
    // Actions
    setUser,
    setLoading,
    setError,
    updateStatus,
    reset
  }
})
